import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import Landing from "./sections/landing";
import Terms from "./sections/terms";
import Reservation from "./sections/reservation";
import Approved from "../global-elements/approved/approved2";
import Declined from "../global-elements/declined";
import { useStoreState } from "easy-peasy";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import "../../../assets/dm/reservation.css";
import Error404 from "../../systempages/error404/Error404";
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import FeaturesService from "../../../services/features";
import { InactiveDetection } from "../../../services/inactiveDetection";
import PaymentFlow from './../activation-payment/layout';
import ReturningPayfee from './../activation-payment/sections/returningPayfee';
import ApprovedGrandBank from "../global-elements/approved/approved_grandbank";
import PDFTerms from "../global-elements/PDFTerms";
import { PRODUCT } from "../../../models/websiteTypesConstants";


function Layout() {
 
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const product = useStoreState(
    (state) => state.siteSettingsModel.brandSettings.ProductName
  );
  const termsStep = useStoreState(state => state.displayPrequalTerms);
  const resultStep = useStoreState(state => state.displayResult);
  const features = new FeaturesService();

  InactiveDetection.setInactiveTitle(null);
  useEffect(() => { 
    document.querySelector("title").textContent = `${brandSettings.ProductName} - Mastercard`;
    InactiveDetection.setTitle(`${brandSettings.ProductName} - Mastercard`);
  }, []);


  return (
    <Switch>
      <Route path="/getTerms/:productCode" component={() => <PDFTerms />} exact />
      {/* Landing page No form */}
      <Route path="/" component={() => <Landing />} exact />
      {/* Reservation Page */}
      {
        features.isFeatureEnabled('ReservationLookUpPageActive') && (
          <Route path="/reservation" component={() => <Reservation />} exact />
        )
      }
      
      {/* Terms page No form */}
      {
        product.toLowerCase() === 'fit' ?
        (
          <>
            <Route path="/terms" component={() => (termsStep) ? <PaymentFlow /> : <Redirect to={"/"+window.location.search} />} exact />
            <Route path="/terms/:dummypath" component={() => (termsStep) ? <PaymentFlow /> : <Redirect to={"/"+window.location.search} />} exact />
            <Route path="/payfee" component={() => <ReturningPayfee />} exact />
          </>
        )
        :
        (
          <>
            <Route path="/terms"    component={() => (termsStep)  ? <Terms />    : <Redirect to={"/"+window.location.search} />} exact />
            <Route path="/approved" component={() => (resultStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/"+window.location.search} />} exact />
            <Route path="/decision" component={() => (resultStep) ? <Declined /> : <Redirect to={"/"+window.location.search} />} exact />
            <Route path="/grandbank" component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/"+window.location.search} />} exact/>
            <Route path="/pendinfo" component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/"+window.location.search} />} exact />
            <Route path="/link-account" component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} />} exact />
          </>
          
        )
        
      }
      {/* Approved Page */}
      
      {/* Terms page No form */}
      
      
      <Route  component={() => <Error404 />}  />
    </Switch>
  );
}

export default Layout;
